import axios from "axios";

import { api } from "../../apis";
import { helperFunction } from "../../constant/helper";
import { types } from "../type";

// set loading
const setLocationLoading = (data) => (dispatch) => {
  dispatch({
    type: types.LocationTypes.LOCATION_SET_LOADING,
    payload: data
  });
};

// clear result
const clearLocationResult = () => (dispatch) => {
  dispatch({
    type: types.LocationTypes.LOCATION_CLEAR_RESULT
  });
};

// unMount locations
const unmountAllLocationsData = () => (dispatch) => {
  dispatch({
    type: types.LocationTypes.LOCATION_UNMOUNT
  });
};

// clear error
const clearLocationErrors = () => (dispatch) => {
  dispatch({
    type: types.LocationTypes.LOCATION_CLEAR_ERRORS
  });
};

const getFunction = async (url, type, errorType, dispatch) => {
  try {
    const getRequestSuccess = await axios.get(url);
    const { data } = getRequestSuccess;
    dispatch({
      type: type,
      payload: data
    });
  } catch (getRequestError) {
    const errorData = {
      data: getRequestError.response.data,
      status: getRequestError.response.status
    };
    dispatch({
      type: errorType,
      payload: errorData
    });
  }
};

const getAllLocation = (loginType) => async (dispatch) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Location_Api.GET_LOCATIONS_API}`;
  const type = types.LocationTypes.GET_LOCATIONS;
  const errorType = types.LocationTypes.LOCATION_GET_ERRORS;
  getFunction(url, type, errorType, dispatch);
};

const getDailyAttendance = (date, locationName, loginType) => async (
  dispatch
) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Location_Api.GET_LOCATIONS_API}/:${locationName}/:${date}`;
  const type = types.LocationTypes.GET_LOCATIONS;
  const errorType = types.LocationTypes.LOCATION_GET_ERRORS;
  getFunction(url, type, errorType, dispatch);
};

const createLocation = (createData, loginType) => async (
  dispatch
) => {
  try {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const createSuccess = await axios.post(
      `${baseUrlNode}${api.Location_Api.CREATE_LOCATIONS_API}`,
      createData
    );
    const { message } = createSuccess.data;
    dispatch({
      type: types.LocationTypes.CREATE_LOCATION,
      payload: message
    });
  } catch (createLocationError) {
    const errorData = {
      data: createLocationError.response.data,
      status: createLocationError.response.status
    };
    dispatch({
      type: types.LocationTypes.LOCATION_GET_ERRORS,
      payload: errorData
    });
  }
};

export {
  setLocationLoading,
  clearLocationErrors,
  clearLocationResult,
  getDailyAttendance,
  getAllLocation,
  createLocation,
  unmountAllLocationsData
};
